<script>
import baseMixin from '@/mixins/baseMixin'
import { SelectBoxField } from '@/models/forms/fields/selectBoxField'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'FormSubmissionSelectBoxField',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: SelectBoxField,
      required: true,
    },
    value: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    compSelectionList() {
      const selection = []

      for (const key of Object.keys(this.value)) {
        const selectionDisplayText = this.field.options.find(
          (option) => option.value === key
        )
        if (selectionDisplayText)
          selection.push(selectionDisplayText.displayText)
      }

      return selection
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      <v-chip-group>
        <v-chip v-for="selection of compSelectionList" :key="selection">
          {{ selection }}</v-chip
        >
      </v-chip-group>
    </InfoLabel>
  </div>
</template>
